import stanfordLogo from "@/assets/stanford-eng-comp-forum.png";
import stanfordIcon from "@/assets/stanford-icon.jpg";
import uscLogo from "@/assets/usc-aiken-logo.jpg";
import uscIcon from "@/assets/usc-aiken-icon.png";
import purdueLogo from "@/assets/purdue-business-logo.png";
import purdueIcon from "@/assets/purdue-business-icon.webp";
import uvaDardenLogo from "@/assets/uva-darden-logo.svg";
import uvaDardenIcon from "@/assets/uva-darden-icon.jpg";
import sierraLogo from "@/assets/sierra-logo.png";
import sierraIcon from "@/assets/sierra-icon.png";
import jessupLogo from "@/assets/jessup-logo.png";
import jessupIcon from "@/assets/jessup-icon.png";
import pbaLogo from "@/assets/pba-logo.svg";
import pbaIcon from "@/assets/pba-icon.jpeg";
import calStateLongBeachLogo from "@/assets/cal-state-long-beach-logo.png";
import calStateLongBeachIcon from "@/assets/cal-state-long-beach-icon.png";
import lsacLawhubLogo from "@/assets/lawhub-banner.png";
import lsacLawhubIcon from "@/assets/lawhub-favicon.png";
import { IPartner } from "@/types/ApiTypes";
import { lawhubPrimary } from "@/styles/colors";

export const DEMO_PARTNERS: (Partial<IPartner> & {
  allowInProduction?: boolean;
  styles?: any;
  slug: string;
  aliasSlugs?: string[];
  hideFromLogin?: boolean;
  showMBAToggle?: boolean;
  partnerEmailFormat?: string;
  alumniWording?: {
    singular: string;
    plural: string;
    alumniReplacement: string;
  };
})[] = [
  {
    slug: "university-of-arizona---eller-college-of-management",
    showMBAToggle: true,
    allowInProduction: true,
  },
  {
    slug: "usd-knauss-school-of-business",
    showMBAToggle: true,
    allowInProduction: true,
    // logoURL:
    //   "https://static.wixstatic.com/media/ff2a77_a4ff4a9d02de476890089896b483b443~mv2.jpeg",
    iconURL:
      "https://static.wixstatic.com/media/ff2a77_a4ff4a9d02de476890089896b483b443~mv2.jpeg",
    styles: {
      loginHeaderImageProps: {
        fit: "contain",
      },
    },
  },
  {
    slug: "asu-w.p.-carey-school-of-business",
    showMBAToggle: true,
    allowInProduction: true,
    title: "Arizona State University (ASU) - W. P. Carey",
  },
  {
    slug: "ucla-anderson",
    showMBAToggle: true,
    allowInProduction: true,
  },
  {
    id: "stanford-eng-comp-forum",
    allowInProduction: false,
    title: "Stanford Engineering Computer Forum",
    slug: "stanford-eng-comp-forum",
    partnerType: "University Partner",
    emailFormat: "@stanford.edu",
    logoURL: stanfordLogo,
    bannerImageURL: stanfordLogo,
    iconURL: stanfordIcon,
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 400,
        ratio: 3 / 1,
      },
      signInButtonProps: {
        variant: "filled",
        color: "secondary.9",
      },
    },
    createdAt: new Date(),
    updatedAt: new Date(),
  },
  {
    id: "usca",
    slug: "usca",
    allowInProduction: true,
    title: "University of South Carolina Aiken",
    partnerType: "University Partner",
    emailFormat: "@usca.edu",
    logoURL: uscLogo,
    bannerImageURL: uscLogo,
    iconURL: uscIcon,
    createdAt: new Date(),
    updatedAt: new Date(),
  },

  // {
  //   id: "university-of-arizona---eller-college-of-management",
  //   slug: "university-of-arizona---eller-college-of-management",
  //   allowInProduction: true,
  //   // title: "The University of Arizona Eller College of Management",
  //   // slug: "arizona-eller",
  //   // partnerType: "University Partner",
  //   // emailFormat: "@arizona.edu",
  //   // logoURL: arizonaEllerLogo,
  //   // bannerImageURL: arizonaEllerLogo,
  //   // iconURL: arizonaEllerIcon,
  //   // createdAt: new Date(),
  //   // updatedAt: new Date(),
  //   // styles: {
  //   //   loginHeaderImageProps: {
  //   //     w: "100%",
  //   //     maw: 400,
  //   //     fit: "contain",
  //   //   },
  //   //   signInButtonProps: {
  //   //     variant: "filled",
  //   //     color: "secondary.9",
  //   //   },
  //   // },
  // },
  {
    id: "purdue-university-mitch-daniels-school-of-business",
    slug: "purdue-university-mitch-daniels-school-of-business",
    title: "Purdue University Mitch Daniels School of Business",
    partnerType: "University Partner",
    emailFormat: "@purdue.edu",
    logoURL: purdueLogo,
    bannerImageURL: purdueLogo,
    iconURL: purdueIcon,
    createdAt: new Date(),
    updatedAt: new Date(),
    allowInProduction: false,
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 350,
        fit: "contain",
      },
    },
  },
  {
    id: "uva-darden-school-of-business",
    slug: "uva-darden-school-of-business",
    title: "University of Virginia Darden School of Business",
    partnerType: "University Partner",
    emailFormat: "@virginia.edu",
    logoURL: uvaDardenLogo,
    bannerImageURL: uvaDardenLogo,
    iconURL: uvaDardenIcon,
    createdAt: new Date(),
    updatedAt: new Date(),
    allowInProduction: false,
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 400,
        fit: "contain",
      },
    },
  },
  {
    id: "sierra-college",
    slug: "sierra-college",
    title: "Sierra College",
    partnerType: "University Partner",
    emailFormat: "@sierracollege.edu|@student.sierracollege.edu",
    allowInProduction: true,
    logoURL: sierraLogo,
    bannerImageURL: sierraLogo,
    iconURL: sierraIcon,
    createdAt: new Date(),
    updatedAt: new Date(),
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 350,
        fit: "contain",
      },
    },
  },
  {
    id: "jessup-university",
    slug: "jessup-university",
    aliasSlugs: ["jessup-univeresity"],
    title: "Jessup University",
    partnerType: "University Partner",
    emailFormat: "@jessup.edu",
    allowInProduction: true,
    logoURL: jessupLogo,
    bannerImageURL: jessupLogo,
    iconURL: jessupIcon,
    createdAt: new Date(),
    updatedAt: new Date(),
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 400,
        fit: "contain",
      },
      iconStyles: {
        padding: 2,
        objectFit: "contain",
        borderRadius: 6,
      },
    },
  },
  {
    slug: "compass-diversified",
    hideFromLogin: true,
    allowInProduction: true,
  },
  {
    id: "palm-beach-atlantic-university",
    slug: "palm-beach-atlantic-university",
    title: "Palm Beach Atlantic University",
    partnerType: "University Partner",
    emailFormat: "@pba.edu",
    logoURL: pbaLogo,
    bannerImageURL: pbaLogo,
    iconURL: pbaIcon,
    createdAt: new Date(),
    updatedAt: new Date(),
    allowInProduction: true,
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 350,
        fit: "contain",
      },
    },
  },
  {
    id: "csu-long-beach",
    slug: "csu-long-beach",
    allowInProduction: false,
    title: "California State University Long Beach",
    partnerType: "University Partner",
    emailFormat: "@csulb.edu",
    logoURL: calStateLongBeachLogo,
    bannerImageURL: calStateLongBeachLogo,
    iconURL: calStateLongBeachIcon,
    createdAt: new Date(),
    updatedAt: new Date(),
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 400,
        fit: "contain",
      },
    },
  },
  {
    id: "lawhub",
    slug: "lawhub",
    allowInProduction: true,
    title: "LawHub",
    // emailFormat: "@lsac.edu",
    logoURL: lsacLawhubLogo,
    bannerImageURL: lsacLawhubLogo,
    iconURL: lsacLawhubIcon,
    createdAt: new Date(),
    updatedAt: new Date(),
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 400,
        fit: "contain",
        borderRadius: 6,
      },
      iconStyles: {
        borderRadius: 0,
        border: "0px solid transparent",
        backgroundColor: lawhubPrimary[9],
      },
    },
  },
  {
    id: "alliance-college-ready-public-schools",
    slug: "alliance-college-ready-public-schools",
    allowInProduction: true,
    logoURL:
      "https://static.wixstatic.com/media/ff2a77_397ff347c0b545fa8c5128a520e3a5e7~mv2.png",
    iconURL:
      "https://static.wixstatic.com/media/ff2a77_397ff347c0b545fa8c5128a520e3a5e7~mv2.png",
    bannerImageURL:
      "https://static.wixstatic.com/media/ff2a77_c4ee2a85f0434936bf3bbf2fd8b0d9a3~mv2.png",
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 400,
        fit: "contain",
        borderRadius: 6,
      },
    },
  },
  {
    id: "central-washington-university",
    slug: "central-washington-university",
    allowInProduction: true,
    title: "Central Washington University",
    partnerType: "University Partner",
    emailFormat: "@cwu.edu",
    iconURL:
      "https://static.wixstatic.com/media/ff2a77_233becbc93534ed8ab901f8b15607bb0~mv2.jpg",
    logoURL:
      "https://static.wixstatic.com/media/ff2a77_a727db88b6d64c2fb68ea031fdf4a03f~mv2.jpg",
    bannerImageURL:
      "https://static.wixstatic.com/media/ff2a77_a727db88b6d64c2fb68ea031fdf4a03f~mv2.jpg",
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 400,
        fit: "contain",
        borderRadius: 6,
      },
    },
    // logoURL: cwuLogo,
  },
  {
    id: "smu",
    slug: "smu",
    aliasSlugs: ["southern-methodist-university"],
    allowInProduction: true,
    title: "Southern Methodist University",
    partnerType: "University Partner",
    emailFormat: "@smu.edu",
    iconURL:
      "https://static.wixstatic.com/media/ff2a77_a1c17db480fb455daa85a42bd8ea2e40~mv2.png",
    bannerImageURL:
      "https://static.wixstatic.com/media/ff2a77_a1c17db480fb455daa85a42bd8ea2e40~mv2.png",
    logoURL:
      "https://static.wixstatic.com/media/ff2a77_064f953ced4b43bdac53a8534edff3bf~mv2.png",
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 400,
        fit: "contain",
        borderRadius: 6,
      },
    },
  },
  {
    id: "wbu",
    slug: "wbu",
    allowInProduction: true,
    title: "Wayland Baptist University",
    partnerType: "University Partner",
    emailFormat: "@wbu.edu",
    iconURL:
      "https://static.wixstatic.com/media/ff2a77_954fd9e369e84d359e7d8c685acb6769~mv2.png",
    bannerImageURL:
      "https://static.wixstatic.com/media/ff2a77_7687f9491c11452ba1a0d1e6e948019c~mv2.jpeg",
    logoURL:
      "https://static.wixstatic.com/media/ff2a77_12507c6e016f4cfbb313c726e72f8c90~mv2.png",
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 400,
        fit: "contain",
        borderRadius: 6,
        backgroundColor: "#084a8e",
      },
      iconStyles: {
        backgroundColor: "#084a8e",
      },
    },
    // logoURL: wbuLogo,
    // bannerImageURL: wbuLogo,
  },
  {
    id: "utk-haslam",
    slug: "utk-haslam",
    allowInProduction: true,
    title:
      "Haslam College of Business at the University of Tennessee, Knoxville",
    partnerType: "University Partner",
    emailFormat: "@utk.edu",
    iconURL:
      "https://static.wixstatic.com/media/ff2a77_ec4f171340c74eb0ac5cfe720d6949f3~mv2.png",
    logoURL:
      "https://static.wixstatic.com/shapes/ff2a77_9556ca5c61314a0fa1c599e45847b356.svg",
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 400,
        fit: "contain",
        borderRadius: 6,
      },
    },
  },
  {
    id: "unlv",
    slug: "unlv",
    aliasSlugs: ["university-of-nevada%2C-las-vegas"],
    allowInProduction: true,
    title: "University of Nevada, Las Vegas",
    partnerType: "University Partner",
    emailFormat: "@unlv.edu|@unlv.nevada.edu",
    iconURL:
      "https://static.wixstatic.com/media/ff2a77_13d1a117fe2145658f2df15d4250920c~mv2.jpg",
    logoURL:
      "https://static.wixstatic.com/media/ff2a77_f947c4623f194591a4ff79cd4a437080~mv2.jpg",
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 400,
        fit: "contain",
        borderRadius: 6,
      },
    },
  },
  {
    id: "foreseeable-futures",
    slug: "foreseeable-futures",
    allowInProduction: true,
    title: "Foreseeable Futures",
    partnerType: "University Partner",
    iconURL:
      "https://static.wixstatic.com/media/ff2a77_4fc4b61ef3574450b62612292a59a990~mv2.png",
    logoURL:
      "https://static.wixstatic.com/media/ff2a77_8e1cedb2f88842b08eece4ff42329ca1~mv2.avif",
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 400,
        fit: "contain",
        borderRadius: 6,
      },
    },
  },
  {
    id: "eagle-academy-foundation",
    slug: "eagle-academy-foundation",
    allowInProduction: true,
    partnerType: "University Partner",
    title: "The Eagle Academy Foundation",
    logoURL:
      "https://static.wixstatic.com/media/ff2a77_9f9adfd77ab84efe94657925452a2794~mv2.png",
    iconURL:
      "https://static.wixstatic.com/media/ff2a77_650be319764a412ba3466b441fc20506~mv2.jpeg",
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 400,
        fit: "contain",
        borderRadius: 6,
      },
    },
  },
  {
    id: "northshore",
    slug: "northshore",
    allowInProduction: true,
    title: "North Shore Community College",
    partnerType: "University Partner",
    emailFormat: "@northshore.edu",
    iconURL:
      "https://static.wixstatic.com/media/ff2a77_a75e2c97540449a99392a423bccb253e~mv2.jpeg",
    logoURL:
      "https://static.wixstatic.com/media/ff2a77_83a491066c3c4671aec48f54545aceda~mv2.webp",
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 400,
        fit: "contain",
        borderRadius: 6,
      },
    },
  },
  {
    id: "miami",
    slug: "miami",
    aliasSlugs: ["university-of-miami"],
    allowInProduction: true,
    title: "University of Miami",
    partnerType: "University Partner",
    emailFormat: "@miami.edu",
    iconURL:
      "https://static.wixstatic.com/media/ff2a77_3cad7db82ac949ab9ea35f28314c1726~mv2.jpg",
    logoURL:
      "https://static.wixstatic.com/media/ff2a77_e807ed19cb2a4378934db6eecc57f207~mv2.png",
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 400,
        fit: "contain",
        borderRadius: 6,
      },
    },
  },
  {
    id: "pitt",
    slug: "pitt",
    allowInProduction: true,
    title: "University of Pittsburgh",
    partnerType: "University Partner",
    emailFormat: "@pitt.edu",
    iconURL:
      "https://static.wixstatic.com/media/ff2a77_54df950841e5439bad0889f6d94e36f4~mv2.png",
    logoURL:
      "https://static.wixstatic.com/media/ff2a77_8e33e2c17e944e6882ff8c6363d8381e~mv2.png",
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 400,
        fit: "contain",
        borderRadius: 6,
      },
    },
  },
  {
    id: "point-loma",
    slug: "point-loma",
    allowInProduction: true,
    title: "Point Loma Nazarene University",
    partnerType: "University Partner",
    emailFormat: "@pointloma.edu",
    iconURL:
      "https://static.wixstatic.com/media/ff2a77_7f9e2c5100d8465084fb7e12725a85fe~mv2.png",
    logoURL:
      "https://static.wixstatic.com/media/ff2a77_e969e01b27aa47caa82656b3a3e74d14~mv2.jpg",
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 400,
        fit: "contain",
        borderRadius: 6,
      },
      iconStyles: {
        padding: 1,
        objectFit: "contain",
        borderRadius: 6,
      },
    },
  },
  {
    id: "ncsu",
    slug: "ncsu",
    allowInProduction: true,
    title: "NC State University",
    partnerType: "University Partner",
    emailFormat: "@ncsu.edu",
    showMBAToggle: true,
    iconURL:
      "https://static.wixstatic.com/media/ff2a77_094beb26287f49f9874865145622aab4~mv2.png",
    logoURL:
      "https://static.wixstatic.com/media/ff2a77_469952881a7745b0b2f9242db860f54d~mv2.png",
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 400,
        fit: "contain",
        borderRadius: 6,
      },
    },
  },
  {
    id: "santa-clara-university",
    slug: "santa-clara-university",
    allowInProduction: true,
    title: "Santa Clara University",
    partnerType: "University Partner",
    emailFormat: "@scu.edu",
    showMBAToggle: true,
    iconURL:
      "https://static.wixstatic.com/media/ff2a77_ca64ac3ca8bb471f963634923d5d45cf~mv2.jpeg",
    logoURL:
      "https://static.wixstatic.com/media/ff2a77_c11f875d7e5f4737852d056670acadbf~mv2.jpg",
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 400,
        fit: "contain",
        borderRadius: 6,
      },
    },
  },
  {
    // id: "adobe",
    slug: "adobe",
    allowInProduction: true,
    title: "Adobe Certifications",
    partnerType: "Company Partner",
    showMBAToggle: false,
    partnerEmailFormat: "@adobe.com",
    iconURL:
      "https://static.wixstatic.com/media/ff2a77_50e156210d904c07868591315e3b596b~mv2.jpg",
    logoURL:
      "https://static.wixstatic.com/media/ff2a77_84b67c477679404c861c39c19a29a40b~mv2.png",
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 400,
        fit: "contain",
        borderRadius: 6,
      },
    },
  },
  {
    slug: "minds-matter",
    allowInProduction: true,
    alumniWording: {
      singular: "Minds Matter Advizer",
      plural: "Minds Matter Advizers",
      alumniReplacement: "Advizers",
    },
  },
  {
    id: "cuny-york-college",
    slug: "cuny-york-college",
    allowInProduction: false,
    title: "CUNY York College",
    partnerType: "University Partner",
    emailFormat: "cuny.edu",
    iconURL:
      "https://static.wixstatic.com/media/ff2a77_abe8018c2ab941ceae85181cbbe4e1fc~mv2.png",
    logoURL:
      "https://static.wixstatic.com/media/ff2a77_a40037207fba4eceb7d4e168ac715235~mv2.png",
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 400,
        fit: "contain",
        borderRadius: 6,
      },
    },
  },
  {
    id: "usc",
    slug: "usc",
    allowInProduction: true,
    title: "University of Southern California",
    partnerType: "University Partner",
    emailFormat: "@usc.edu",
    iconURL:
      "https://static.wixstatic.com/media/ff2a77_e90c1841a0024914add587d18fb86871~mv2.jpg",
    logoURL:
      "https://static.wixstatic.com/media/ff2a77_a0938f95a16b44d4b6f59fb0a5c5ef47~mv2.png",
    createdAt: new Date(),
  },
  {
    id: "chicago-booth",
    slug: "chicago-booth",
    allowInProduction: true,
    title: "University of Chicago Booth School of Business",
    partnerType: "University Partner",
    emailFormat: "@uchicago.edu|chicagobooth.edu",
    iconURL:
      "https://static.wixstatic.com/media/ff2a77_0da692a7dc474f4e806ecc41f2cb1254~mv2.png",
    logoURL:
      "https://static.wixstatic.com/media/ff2a77_3aa2fbed80094d7fb705cfe5c5fcc397~mv2.webp",
    styles: {
      loginHeaderImageProps: {
        w: "100%",
        maw: 400,
        fit: "contain",
        borderRadius: 6,
      },
      iconStyles: {
        backgroundColor: "#ffffff",
      },
    },
  }
];

// Column	Type	Comment
// id	text
// title	text
// wixId	text NULL
// slug	text
// about	text NULL
// partnerType	text
// website	text NULL
// emailFormat	text NULL
// logoURL	text NULL
// bannerImageURL	text NULL
// iconURL	text NULL
// createdAt	timestamp(3) [CURRENT_TIMESTAMP]
// updatedAt	timestamp(3) [CURRENT_TIMESTAMP]
